export default __webpack_public_path__ + "static/media/user.d2c29148.svg";